"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleWrapper = exports.PageActions = exports.NavMainContent = exports.Nav = exports.NAV_HEIGHT_MEDIUM = exports.ComplementaryContent = exports.AppBarMobileWrapper = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _AppBarMobile = require("./AppBarMobile.types");
var _excluded = ["className", "isFloating", "scrollPosition", "variant"],
  _excluded2 = ["className", "scrollPosition", "variant"],
  _excluded3 = ["className", "scrollPosition"],
  _excluded4 = ["className", "scrollPosition", "variant"],
  _excluded5 = ["className", "noPadding", "scrollPosition"],
  _excluded6 = ["className", "scrollPosition"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "appBarMobileWrapper": "KJh9Px",
  "appBarMobileWrapperFloating": "IZbmzo",
  "appBarMobileWrapperDefault": "hYSfR9",
  "appBarMobileWrapperTransparent": "dilvHZ",
  "appBarMobileWrapperScrolled": "pDWFNg",
  "nav": "pmfd22",
  "navTransparent": "jcnsxs",
  "navScrolled": "l6lNE0",
  "navMainContent": "qX3SUP",
  "navMainContentScrolled": "_9Pz2gT",
  "pageActions": "rhpZe2",
  "pageActionsTransparent": "QiJ8nM",
  "pageActionsScrolled": "_4tY0H2",
  "complementaryContent": "zPD9J7",
  "complementaryContentNoPadding": "_7dO-9Y",
  "titleWrapper": "_0DRrA-",
  "titleWrapperScrolled": "Tgcv6C",
  "appBarMobile__title--main": "Q82aBD",
  "appBarMobile__subtitle": "_3LicPN"
};
var NAV_HEIGHT_MEDIUM = exports.NAV_HEIGHT_MEDIUM = '88px';
var getTransitionMutation = function getTransitionMutation(scrollPosition) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var MAX_SCROLL_POSITION = 40 + delay;
  var MUTATION_STEP = 0.025;
  if (scrollPosition < delay) return 0;
  if (scrollPosition > MAX_SCROLL_POSITION) return 1;
  return MUTATION_STEP * (scrollPosition - delay);
};
var isScrolled = function isScrolled(scrollPosition) {
  return scrollPosition > 0;
};
var calculateTransitionedBoxShadow = function calculateTransitionedBoxShadow($scrollPosition) {
  return "0px 4px 8px rgb(0 0 0 / calc(15% * ".concat(getTransitionMutation($scrollPosition), " )), 0px 8px 32px rgb(0 0 0 / calc(10% * ").concat(getTransitionMutation($scrollPosition), "))");
};
var calculateNavTitleTransitionedMarginTop = function calculateNavTitleTransitionedMarginTop($scrollPosition, delay) {
  return "calc(".concat(_js["default"].alias.spacing.xxsmall, " - ").concat(_js["default"].alias.spacing.xxsmall, " * ").concat(getTransitionMutation($scrollPosition, delay), ")");
};
var isTransparent = function isTransparent(variant) {
  return variant === _AppBarMobile.Variant.TRANSPARENT || variant === _AppBarMobile.Variant.TRANSPARENT_INVERSE;
};
var AppBarMobileWrapper = exports.AppBarMobileWrapper = function AppBarMobileWrapper(_ref) {
  var className = _ref.className,
    isFloating = _ref.isFloating,
    scrollPosition = _ref.scrollPosition,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.appBarMobileWrapper, variant === _AppBarMobile.Variant.DEFAULT && styles.appBarMobileWrapperDefault, isTransparent(variant) && styles.appBarMobileWrapperTransparent, isFloating && styles.appBarMobileWrapperFloating, isScrolled(scrollPosition) && styles.appBarMobileWrapperScrolled)
  }));
};
var Nav = exports.Nav = function Nav(_ref2) {
  var className = _ref2.className,
    scrollPosition = _ref2.scrollPosition,
    variant = _ref2.variant,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement("nav", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.nav, isTransparent(variant) && styles.navTransparent, isScrolled(scrollPosition) && styles.navScrolled),
    style: isScrolled(scrollPosition) ? {
      '--box-shadow': calculateTransitionedBoxShadow(scrollPosition)
    } : {}
  }));
};
var NavMainContent = exports.NavMainContent = function NavMainContent(_ref3) {
  var className = _ref3.className,
    scrollPosition = _ref3.scrollPosition,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.navMainContent, isScrolled(scrollPosition) && styles.navMainContentScrolled),
    style: isScrolled(scrollPosition) ? {
      '--opacity': getTransitionMutation(scrollPosition, 10),
      '--margin-top': calculateNavTitleTransitionedMarginTop(scrollPosition, 10)
    } : {}
  }));
};
var PageActions = exports.PageActions = function PageActions(_ref4) {
  var className = _ref4.className,
    scrollPosition = _ref4.scrollPosition,
    variant = _ref4.variant,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.pageActions, isTransparent(variant) && styles.pageActionsTransparent, isScrolled(scrollPosition) && styles.pageActionsScrolled)
  }));
};
var ComplementaryContent = exports.ComplementaryContent = function ComplementaryContent(_ref5) {
  var className = _ref5.className,
    noPadding = _ref5.noPadding,
    scrollPosition = _ref5.scrollPosition,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.complementaryContent, noPadding && styles.complementaryContentNoPadding),
    style: {
      '--transition-completed': getTransitionMutation(scrollPosition)
    }
  }));
};
var TitleWrapper = exports.TitleWrapper = function TitleWrapper(_ref6) {
  var className = _ref6.className,
    scrollPosition = _ref6.scrollPosition,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({}, props, {
    className: (0, _clsx["default"])(className, styles.titleWrapper, isScrolled(scrollPosition) && styles.titleWrapperScrolled),
    style: isScrolled(scrollPosition) ? {
      '--transition-completed': getTransitionMutation(scrollPosition)
    } : {}
  }));
};